import { render, staticRenderFns } from "./MetaInsightsChannelDetail.vue?vue&type=template&id=9dd1b6bc&scoped=true"
import script from "./MetaInsightsChannelDetail.vue?vue&type=script&lang=js"
export * from "./MetaInsightsChannelDetail.vue?vue&type=script&lang=js"
import style0 from "./MetaInsightsChannelDetail.vue?vue&type=style&index=0&id=9dd1b6bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dd1b6bc",
  null
  
)

export default component.exports